// extracted by mini-css-extract-plugin
module.exports = {"grid":"LandingCards_grid__x13m5","card":"LandingCards_card__HKMGC","title":"LandingCards_title__IoCWH","blurb":"LandingCards_blurb__Zm9fY"};